import React from 'react';
import { Button, Modal, Select } from 'semantic-ui-react';
import { formSelectService, clickableStyles, copytoClipboard } from 'src/components/helpers';
import Swal from 'sweetalert2';

const GenerateLinksModal = (props) => {
  const { previousEventsNames } = props;
  const [nameselected, set_nameselected] = React.useState('');

  const loc = window.location;
  const selectedlink = `${loc?.origin}/servicio/reservacion?event=${nameselected}&id=event`;

  return (
    <>
      <Modal closeIcon trigger={<Button>Links de reserva</Button>}>
        <Modal.Header>
          Selecciona un tipo de evento o auditorio para generar el link de reserva
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <div style={{ margin: '0 10px 0 20px' }}>
              {formSelectService({
                Select,
                label: 'Evento o Auditorio',
                name: 'eventSlugname',
                handler: (a, { value, name }) => set_nameselected(value),
                value: nameselected,
                options: previousEventsNames,
              })}
              {nameselected && (
                <>
                  <div style={{ marginBottom: '15px' }}>
                    <Button
                      onClick={() => window.open(selectedlink, '_blank')}
                      style={{ marginRight: '10px' }}
                    >
                      Ir
                    </Button>
                    <Button
                      color="purple"
                      onClick={() => {
                        const qrUrl = `/utils/generador-qr?url=${encodeURIComponent(selectedlink)}`;
                        window.open(qrUrl, '_blank');
                      }}
                    >
                      Generar QR
                    </Button>
                  </div>
                  <p
                    onClick={() => copytoClipboard({ content: selectedlink, Swal })}
                    style={{ margin: '10px', ...clickableStyles }}
                  >
                    {selectedlink}
                    <br />
                    <small>Click para copiar</small>
                  </p>
                </>
              )}
            </div>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default GenerateLinksModal;
